var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.activeName === 'index')?_c('Header',{staticClass:"app-header"}):_c('Header',{staticClass:"nohome-header"}),_c('div',{staticClass:"app-content"},[_c('router-view')],1),_c('Footer'),(_vm.scrollTop > 1200)?_c('ToolBar',{staticClass:"toobar"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }